import { useVerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity } from '@zg-rentals/ts-rent-payment-client-react-query';
import { logError } from '@zg-rentals/log-error';

export function useVerifyLandlordIdentity(options?: {
  postVerificationFlow?: () => void | Promise<void>;
  onError?: (error: unknown) => void | Promise<void>;
  onSettled?: () => void;
  context?: string;
}) {
  return useVerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity({
    onSuccess: async () => {
      try {
        await options?.postVerificationFlow?.();
      } catch (error) {
        logError({ error, context: options?.context || 'useVerifyLandlordIdentity - postVerificationFlow' });
        await options?.onError?.(error);
      }
    },
    onError: async (error) => {
      logError({ error, context: options?.context || 'useVerifyLandlordIdentity - onError' });
      await options?.onError?.(error);
    },
    onSettled: () => {
      options?.onSettled?.();
    },
  });
}
